import React, { LegacyRef, useCallback, useEffect, useState } from 'react'
import {
	IonContent,
	IonList,
	IonPopover,
	IonHeader,
	IonToolbar,
	IonTitle,
	IonIcon,
	IonText,
	IonButtons,
	useIonPopover,
} from '@ionic/react'
import Button from '../../Button'
import { getDirMode, isRTL } from 'mobile_web/modules/platform'
import { ionHistory } from 'mobile_web/modules/navigation'
import { closeOutline as closeIcon } from 'ionicons/icons'
import { EventActionsEnum, sendEvent } from 'mobile_web/modules/logging/analytics'
import { Collection } from 'mytours-read-common'

import { popoverEnterAnimation, popoverLeaveAnimation } from './animations'

import strings from 'mobile_web/strings'

import classNames from 'classnames'
import './styles.less'

interface Props {
	fullScreen?: boolean
	title?: string
	collection: Collection
	content: JSX.Element
	menuToggleRef?: (ref: HTMLIonButtonElement) => void
}

interface MenuProps {
	title: string | undefined
	content: JSX.Element
	onDismiss: () => void
}

const Menu: React.FC<MenuProps> = ({ title, content, onDismiss }) => (
	<IonContent className="menu-body" forceOverscroll={false}>
		<IonHeader className="header">
			<IonToolbar className="toolbar">
				<IonTitle className="toolbar-title">
					<h1>{title}</h1>
				</IonTitle>
				<IonButtons slot="end" className="header-buttons">
					<Button ariaLabel={strings.close} className="menu-toggle" onClick={onDismiss}>
						<IonIcon className="icon" icon={closeIcon} />
						<IonText className="hidden">{strings.accessibility_go_back}</IonText>
					</Button>
				</IonButtons>
			</IonToolbar>
		</IonHeader>

		<IonList className="list" dir={getDirMode()}>
			{content}
		</IonList>
	</IonContent>
)

export const ToggleMenu: React.FC<Props> = ({ title, content, fullScreen, menuToggleRef }) => {
	const [present, dismiss] = useIonPopover(Menu, {
		title,
		content,
		onDismiss: () => dismiss(),
		style: {
			[isRTL() ? '--left-positon' : '--right-position']: 'calc(max(0px, 50% - var(--max-page-width) / 2))',
		},
	})

	useEffect(() => {
		let prevPath = ionHistory.location.pathname
		let prevSearch = ionHistory.location.search

		const unListen = ionHistory.listen(({ pathname, search }) => {
			if (prevPath !== pathname || prevSearch !== search) {
				dismiss()
			}
			prevPath = pathname
			prevSearch = search
		})

		return () => unListen()
	}, [dismiss])

	return (
		<div className="toggle-menu-container">
			<Button
				ariaLabel={strings.open_menu}
				className="menu-toggle"
				expand="block"
				onClick={() =>
					present({
						side: 'bottom',
						alignment: 'end',
						cssClass: classNames('popover-menu', { 'full-screen': !!fullScreen, rtl: isRTL() }),
						enterAnimation: popoverEnterAnimation,
						leaveAnimation: popoverLeaveAnimation,
					})
				}
				ref={menuToggleRef as unknown as LegacyRef<Button>}
			>
				<i className="icon fal fa-list-ul" />
			</Button>
		</div>
	)
}
